import { DatePickerInput } from 'src/components/date-picker/date-picker-input';
import React from 'react';

export const BulletinTextField: React.FC<{
    id: string;
    label: string;
    placeholder: string;
    maxLength: number;
    value: string;
    onChange: (value: string) => void;
    error?: string;
}> = ({ id, label, placeholder, maxLength, value, onChange, error }) => (
    <div className='c-form-field'>
        <label className='c-form-field__label' htmlFor={id}>
            {label}*
        </label>
        <div className='c-input'>
            <input
                id={id}
                className={`c-input__input ${error ? 'is-error' : ''}`}
                type='text'
                placeholder={placeholder}
                maxLength={maxLength}
                value={value}
                onChange={(event) => onChange(event.target.value)}
            />
        </div>
        {error && <span className='c-error-message'>{error}</span>}
    </div>
);

export const BulletinDateField: React.FC<{
    label: string;
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    error?: string;
    minDate?: Date;
}> = ({ label, placeholder, value, onChange, error, minDate }) => (
    <div className='c-form-field'>
        <label className='c-form-field__label'>{label}</label>
        <div
            className={`upload-bulletin__date-picker ${
                error ? 'is-error' : ''
            }`}
        >
            <DatePickerInput
                selectedDate={value}
                handleOnClose={onChange}
                {...(minDate && { minDate })}
            />
            <span className='upload-bulletin__date-placeholder'>
                {!value && placeholder}
            </span>
        </div>
        {error && <span className='c-error-message'>{error}</span>}
    </div>
);
